import i18n from 'utility/Translate/I18n';

export enum PriceFormatter {
    WithFractionDigits = 'WithFractionDigits',
    NoFractionDigits = 'NoFractionDigits',
}

const PriceFormatters = {
    [PriceFormatter.NoFractionDigits]: new Intl.NumberFormat(
        i18n.t('TRANS-locale'),
        {
            style: 'currency',
            currency: i18n.t('TRANS-currency'),
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }
    ),
    [PriceFormatter.WithFractionDigits]: new Intl.NumberFormat(
        i18n.t('TRANS-locale'),
        {
            style: 'currency',
            currency: i18n.t('TRANS-currency'),
        }
    ),
};

export const getFormattedPrice = (
    price: number,
    formatter: PriceFormatter = PriceFormatter.NoFractionDigits,
    forceRoundUp?: boolean
): string => {
    const priceAmount = forceRoundUp ? Math.ceil(price) : price;

    return PriceFormatters[formatter].format(priceAmount);
};
